/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_Delete_Confirm_YesInputs */



/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Decks_Delete_Confirm_YesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_delete_confirm_yes = /** @type {((inputs?: Decks_Delete_Confirm_YesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Delete_Confirm_YesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Excluir")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina")
	return /** @type {LocalizedString} */ ("Delete")
});